<script>
import { user, userRol} from '../../stores/user'
    import { navigate } from "svelte-routing";
    import {onMount} from 'svelte'
    import {auth} from '../../firebase'
    import { panelController,dataReset} from '../../stores/service'

    const cerrarSesion = () => {
        auth.signOut()
        user.setUser(null)
        
        $panelController = dataReset();
        navigate('/', { replace: true })
    }
    

    onMount(async () => {
        if(!$user){
            navigate('/', { replace: true })
        }
        
    })
</script>

{#if $user}

<div class="lockscreen-wrapper">
  <div class="lockscreen-logo">
    <a href="../../index2.html"><b>Admin</b></a>
    <div class="lockscreen-name">{$user.displayName}</div>
  </div>
  <!-- User name -->

  <!-- START LOCK SCREEN ITEM -->
  <div class="lockscreen-item">
    <!-- lockscreen image -->
    <div class="lockscreen-image">
      <img src={$user.photoURL} alt="User Image">
    </div>
    <!-- /.lockscreen-image -->

    <!-- lockscreen credentials (contains the form) -->
    <form class="lockscreen-credentials">
      <div class="input-group">
        <input type="password" class="form-control" placeholder={$user.email}>
      </div>
    </form>
    <!-- /.lockscreen credentials -->
    <button class="btn btn-primary btn-block" on:click={cerrarSesion}>Salir</button>
  </div>

  <!-- <div>
    <a use:link href="/homee">home</a>
  </div> -->
  <!-- /.lockscreen-item -->
</div>

{/if}


